/* eslint-env es6 */
/* eslint-disable */
import ndRes from 'nd.res';
    export default ndRes.templates;
